module.exports = __webpack_public_path__ + "static/media/announcement-views.6cead1d9.svg";